import React from "react";
import FNum from "../../Utils/FormatNumber";
import HideableBox from "../Generic/HideableBox";
import ProbabilityTable from "./ProbabilityTable";
import DivButton from "../Generic/DivButton";
export default function ResultDisplay(props) {
  const MCData = props.MCData;
  if (MCData !== "") {
    const dummyData = {
      Timeline: 30,
      ROR: 3.1,
      SD: 3.1,
      OriginalFundingValue: 1000,
      AmountToInvestAnnually: 1,
      Target: 10000,
    };
    const inputData = MCData.req;
    const tableData = MCData.res.percentiles;
    function clear() {
      props.clear();
    }
    return (
      <div className="MCTableContainer" onClick={props.onClick}>
        <div>
          <h2>
            Simulation {props.label} <span>Click to Delete</span>
          </h2>
        </div>
        <HideableBox
          label="inputs"
          ClassList={"MCHidden"}
          hiddenByDefault={false}
        >
          <div className="MCDataLine">
            <span>Iterations:</span> 10,000
          </div>
          <div className="MCDataLine">
            <span>Timeline:</span> {inputData.Timeline} years
          </div>
          <div className="MCDataLine">
            <span>Rate of Return:</span> {inputData.ROR}%
          </div>
          <div className="MCDataLine">
            <span>Standard Deviation: </span>
            {inputData.SD}%
          </div>
          <div className="MCDataLine">
            <span>Original Funding Value:</span> $
            {FNum(inputData.OriginalFundingValue)}
          </div>
          <div className="MCDataLine">
            <span>
              {parseFloat(
                FNum(inputData.AmountToInvestAnnually).replaceAll(",", "")
              ) >= 0
                ? "Amount To Invest Annually:"
                : "Amount To Spend Annually:"}
            </span>{" "}
            ${FNum(inputData.AmountToInvestAnnually)}
          </div>
          <div className="MCDataLine">
            <span>Target: </span>${FNum(inputData.Target)}
          </div>
        </HideableBox>
        <div className="MCDataBox">
          <div className="MCDataLine">
            Simulation Average: <span>${FNum(MCData.res.stats.Average)}</span>
          </div>
          <div className="MCDataLine">
            Probability of Hitting Target:{" "}
            <span>{FNum(MCData.res.stats.PercentOfTarget)}%</span>
          </div>
          {/* <div className="MCDataLine">
            Mean <span>{MCData.res.stats.Mean}</span>
          </div> */}
        </div>
        <ProbabilityTable tableData={tableData}></ProbabilityTable>
      </div>
    );
  }
  return (
    <>
      <div className="MCTableContainer"></div>
    </>
  );
}
